// src/hooks/use-dismiss.ts
import { useState, useCallback, useEffect } from "react";
var useDismiss = (autoDismiss, onDismiss) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const handleDismiss = useCallback(event => {
    setIsDismissed(true);
    onDismiss == null ? void 0 : onDismiss(event);
  }, [onDismiss]);
  useEffect(() => {
    if (autoDismiss) {
      const timeout = setTimeout(() => {
        setIsDismissed(true);
      }, autoDismiss);
      return () => clearTimeout(timeout);
    }
    return void 0;
  }, [autoDismiss, setIsDismissed]);
  return {
    isDismissed,
    handleDismiss
  };
};
var use_dismiss_default = useDismiss;
export { use_dismiss_default };